module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGEAAAAWCAYAAADQIfLaAAABO0lEQVRoge2ZAQ7CMAhFndlhvKIn8IreZloTDBKgLawdKi9Zuk0KlV+6TpftySk5lPPRA0hShBCkCAFY4WS53s1Ottvl1R/aml3tXlTKWEew4ouWIN6E4Rjgi8bdUxQuXjQ+RLDMUmrDCUmrhKscKZa3UiShI7HbMwEnq7T4oGA7SA4+xz7/AZcIPaWOk1xaOPB1r89fwSyCtkzQJAO4AmhL71nGw4na0kebEDOqca2b8GjJal3budnvGY+liqid1Y+Hae8J3JrPVcIeMXoEkCp25tZ5iAhcmRfoTqX2TLDE5cTWgAmA+1j8eDAvRxqtD2m6tdWWq1ZbakOTi8fHJVnyM5IhIkjQbWztC0qfadte7dzjZyRvEaTSk16+euES/g0vUjNY8v+E48lfUQOQIgQgRQhAihCAFCEADz1kCFQurulnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/SaveFile/bctb1-6.png
// module id = 828
// module chunks = 0